module.exports = __webpack_public_path__ + "img/icon_text_left@3x.905ea8f6.png";